import { render, staticRenderFns } from "./CircleChart.vue?vue&type=template&id=4834d163&scoped=true&"
import script from "./CircleChart.vue?vue&type=script&lang=js&"
export * from "./CircleChart.vue?vue&type=script&lang=js&"
import style0 from "./CircleChart.vue?vue&type=style&index=0&id=4834d163&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4834d163",
  null
  
)

export default component.exports